import employeeService from 'services/employee-service';
import patientService from "services/patient-service";

const defaultProfile = {
  userId: null,
  token: null,
  password: null,
  confirmPassword: null,
  lastName: null,
  firstName: null,
  email: null,
  phoneNumber: null,
  agreementAccepted: null,
  isPatient: null,
  physicianNPI: null
};

const state = {
    profile: { ...defaultProfile }
};

const mutations = {
  ["update"](state, profile) {
    state.profile = { ...state.profile, ...profile };
  },
};

const actions = {
  async updateProfile({ commit, state }) {
    let userData = state.profile.isPatient
      ? await patientService.getByUserId(state.profile.userId)
      : await employeeService.getByUserId(state.profile.userId);

    commit("update", userData);
  },

  async createPatientProfile({ state }) {
    await patientService.createProfile(state.profile);
  },

  async createClientProfile({ state }) {
    await employeeService.createProfile(state.profile);
  }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};